<template>
  <div class="flex flex-direction" id="guest">
    <Title :ch="'重磅嘉宾'" :bg-img="titleBgImg"></Title>
    <div class="guest-container">
      <div class="pc">
        <div class="guest_list flex align-center swiper-no-swiping">
          <div class="swiper-container-guest flex align-end">
            <div
              class="swiper-wrapper swiper-wrapper-guest flex align-end"
              :class="{ notFirstMarginLeft: realIndex > 0 }"
            >
              <div
                class="swiper-slide swiper-slide-guest flex flex-direction justify-between"
                v-for="(guest, index) in guests"
                :ref="'swiper_' + index"
                :key="index"
                :data-index="index"
                @mouseenter="changeCurrent(index)"
                @mouseleave="changeCurrent(-1)"
                @click="didClick_guest(guest.name)"
                :class="{ active: now_swiper === index }"
              >
                <div class="swiper-text">
                  <div class="name">{{ guest.name }}</div>
                  <div class="red-line"></div>
                  <div
                    class="position ellipsis-2"
                    v-html="guest.enterprise + guest.duty"
                  ></div>
                </div>
                <img class="swiper-img" :src="guest.realPath_new" />
                <img
                  class="select-img"
                  src="../assets/images/guest/home/select-bg-pc.png"
                />
                <img
                  v-show="now_swiper !== index"
                  class="select-img1-default"
                  src="../assets/images/guest/home/default.png"
                />
              </div>
            </div>
          </div>
          <!-- 如果需要导航按钮 -->
          <div
            class="swiper-button-prev cs"
            @click="prevSwiper"
            v-if="guests.length > 6"
            :class="now_swiper == 0 ? 'swiper-button-prev-dis' : ''"
          >
            <img :src="ArrowUrl" />
          </div>
          <div
            class="swiper-button-next cs"
            @click="nextSwiper"
            v-if="guests.length > 6"
            :class="
              now_swiper == guests.length - 1 ? 'swiper-button-next-dis' : ''
            "
          >
            <img :src="ArrowUrl" />
          </div>
        </div>
      </div>
      <div class="wap">
        <div
          class="swiper-container-guest-wap flex"
          style="width: 100%; height: 100%"
        >
          <div
            class="swiper-wrapper flex"
            style="
              width: 100%;
              height: calc(100% - 30px);
              border: 1px solid greenyellow;
            "
          >
            <div
              class="swiper-slide flex"
              style="
                width: 100%;
                height: 100%;
                transform: translate3d(0, 0, 0);
                overflow: hidden;
              "
              v-for="(guest, index) in guests"
              :key="index"
              @mouseenter="now_swiper = index"
              @click="now_swiper = index"
            >
              <div class="slide" style="width: 100%; height: 100%">
                <div class="swiper-text">
                  <div class="name">{{ guest.name }}</div>
                  <div class="red-line"></div>
                  <div
                    class="position"
                    v-html="guest.enterprise + guest.duty"
                  ></div>
                </div>
                <img class="swiper-img" :src="guest.realPath_new" />
              </div>
            </div>
          </div>
          <!--     小圆点分页器       -->
          <div
            class="swiper-pagination-news flex align-center justify-center"
            slot="pagination"
            style="width: 100%; height: 20px"
          ></div>
        </div>
      </div>
    </div>
    <DidLink @click.native="lookMore"></DidLink>
    <!--    <div-->
    <!--      v-if="$store.state.isMobile"-->
    <!--      class="link-new flex align-center justify-center cs"-->
    <!--    >-->
    <!--      <span @click="lookMore"> 查看更多 >></span>-->
    <!--    </div>-->
  </div>
</template>

<script>
import Title from "./common/Title";
import "../../node_modules/swiper/css/swiper.css";
import Swiper from "swiper";
import { staticApi } from "../services";
import _ from "lodash";

var self;
export default {
  name: "Guest",
  data() {
    return {
      titleBgImg: require("../assets/images/guest/home/title.png"),
      ArrowUrl: require("../assets/images/videos/arrow.png"),
      guests: [],
      swiper_video_pc: null,
      now_swiper: 0,
      defaultNum: 0,
      realIndex: 0,
      currentItem: {},
    };
  },
  components: {
    Title,
  },
  mounted() {
    //获取 重磅嘉宾 首页 数据
    this.getGuestList();
    self = this;
  },
  methods: {
    //点击嘉宾
    didClick_guest(name) {
      //埋码
      window._hw("send", "action", "index_guest_information_click ", {
        guest_name: name,
      });
    },
    prevSwiper() {
      if (this.now_swiper <= 0) {
        return;
      }
      this.now_swiper = this.now_swiper - 1;

      if (this.now_swiper < this.guests.length - 6) {
        const currentItem =
          document.getElementsByClassName("swiper-slide-guest")[
            this.now_swiper
          ];
        const container = document.getElementsByClassName(
          "swiper-wrapper-guest"
        )[0];
        container.style.marginLeft = "-" + currentItem.offsetLeft + "px";
      }
    },
    nextSwiper() {
      if (this.now_swiper >= this.guests.length - 1) {
        return;
      }
      if (this.now_swiper < this.guests.length - 6) {
        const currentItem =
          document.getElementsByClassName("swiper-slide-guest")[
            this.now_swiper
          ];
        const container = document.getElementsByClassName(
          "swiper-wrapper-guest"
        )[0];
        container.style.marginLeft =
          "-" +
          currentItem.offsetLeft -
          (250 * document.documentElement.clientWidth) / 1920 +
          "px";
      }
      this.now_swiper = this.now_swiper + 1;
    },
    changeCurrent(index) {
      if (index >= 0) {
        this.realIndex = _.cloneDeep(this.now_swiper);
        this.now_swiper = index;
      } else {
        this.now_swiper = _.cloneDeep(this.realIndex);
      }
    },
    loadSwiper() {
      if (self.$store.state.isMobile) {
        //wap端 swiper
        self.swiper_news = new Swiper(".swiper-container-guest-wap", {
          loop: true, //首尾循环
          // centeredSlides: false,
          // slidesPerView: 1.19, //每组 有多少块
          // loopedSlides: 10,
          // spaceBetween: 18, //板块间隔
          // slidesPerGroup: 1, //多少个板块为1组。
          pagination: {
            el: ".swiper-pagination-news",
            clickable: true,
            bulletClass: "my-bullet",
            bulletActiveClass: "my-bullet-active",
          },
          slidesPerView: "auto",
          centeredSlides: true,
        });
      } else {
        const params = {
          loop: false,
          slidesPerView: "auto",
          initialSlide: 0,
          mousewheel: false,
          mousewheelControl: false,
          simulateTouch: false, //禁止鼠标模拟
          loopAdditionalSlides: 0,
          navigation: {
            prevEl: ".swiper-button-prev",
            nextEl: ".swiper-button-next",
          },
        };
        // //pc端 swiper
        // self.swiper_video_pc = new Swiper(".swiper-container-guest", params);
        // self.swiper_video_pc.on('slideChange', function () {
        //   self.realIndex = self.swiper_video_pc.activeIndex;
        // });
      }
    },
    lookMore() {
      window._hw("send", "action", "index_check_more_all_click", {
        module_name: "重磅嘉宾",
      });
      this.$router.push({
        path: "/guest",
      });
    },
    handleInvite(e, idx) {
      if (e.path[1].attributes[3]) {
        this.now_swiper = e.path[1].attributes[3].nodeValue;
      } else {
        this.now_swiper = e.path[2].attributes[3].nodeValue;
      }
    },
    getGuestList() {
      // 嘉宾列表
      staticApi
        .request(
          `/${this.$config.tenantId}/seminar/${this.$config.guestListId}/guest.json`
        )
        .then((res) => {
          if (res.result == 0) {
            let list = res.content;
            var newList = list.filter((item) => {
              return item.isRecommendHome == "1";
            });
            // .sort(function (a, b) {
            //   return a.guestsOrder - b.guestsOrder;
            // })
            //排序 有自定义使用自定义  无自定义 使用创建时间倒叙
            newList.forEach((item) => {
              item.realPath_new = "";
              if (item.realPath) {
                item.realPath_new = item.realPath.replace(
                  /^.*\/\/hwyhw.smarket.net.cn/,
                  "https://hwyhw-files.smarket.net.cn"
                );
              }
            });
            newList.sort((a, b) => {
              if (a.guestsOrder == b.guestsOrder) {
                //若排序相等 比较 开始时间 和结束时间
                const aCreated_at = new Date(a.createTime).getTime();
                const bCreated_at = new Date(b.createTime).getTime();
                //创建时间倒叙 排序
                return bCreated_at - aCreated_at;
              }
              return b.guestsOrder - a.guestsOrder;
            });
            this.guests = newList;
            this.$nextTick(() => {
              // 初始化swiper
              this.loadSwiper();
              this.$bus.$emit("ready", "guest");
            });
          }
        })
        .catch((error) => {
          console.log("获取嘉宾列表失败", error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
// guest begin
#guest {
  width: 100%;
}

// guest end
@media screen and (min-width: 992px) {
  #guest {
    width: 100%;
    padding: 60px 160px 60px 160px;

    .guest-container {
      width: 1600px;
      height: 600px;

      .pc {
        width: 100%;
        height: 100%;

        .guest_list {
          width: 1600px;
          height: 100%;
          margin: 0 auto;
          position: relative;

          .swiper-button-prev {
            width: 69px;
            height: 69px;
            z-index: 100;
            background: #151e26;
            opacity: 0.24;
            position: absolute;
            top: 530px;
            left: -30px;
            border-radius: 50%;
            line-height: 69px;
            text-align: center;

            &::after {
              content: "";
            }

            img {
              width: 30px;
              height: 16px;
              transform: rotate(90deg);
            }
          }

          .swiper-button-prev:hover {
            background-color: rgba(180, 37, 30, 1);
          }
          .swiper-button-prev-dis {
            background-color: #151e26;
            cursor: not-allowed;
          }
          .swiper-button-prev-dis:hover {
            background-color: #151e26;
          }

          .swiper-button-next {
            width: 69px;
            height: 69px;
            opacity: 0.24;
            position: absolute;
            top: 530px;
            right: -30px;
            background-color: #151e26;
            border-radius: 50%;
            line-height: 69px;
            text-align: center;

            &::after {
              content: "";
            }

            img {
              width: 30px;
              height: 16px;
              transform: rotate(270deg);
            }
          }

          .swiper-button-next:hover {
            background-color: rgba(180, 37, 30, 1);
          }
          .swiper-button-next-dis {
            background-color: #151e26;
            cursor: not-allowed;
          }
          .swiper-button-next-dis:hover {
            background-color: #151e26;
          }

          ::v-deep .swiper-container-guest,
          .swiper-container-initialized,
          .swiper-container-horizontal {
            width: 1598px;
            height: 100%;
            position: relative;
            overflow-x: hidden;
            overflow-y: auto;

            .swiper-wrapper {
              height: 600px;
              width: 250px;
              //margin-top: 48px;
              .swiper-slide {
                height: 550px;
                width: 250px !important;
                overflow-x: hidden;
                background: rgba(255, 255, 255, 0.26);
                border: 1px solid;
                border-image: linear-gradient(
                    160deg,
                    rgba(255, 255, 255, 1),
                    rgba(235, 235, 235, 0),
                    rgba(235, 235, 235, 0),
                    rgba(255, 255, 255, 0.62)
                  )
                  2 2;
                opacity: 1;
                filter: blur(undefinedpx);

                .swiper-text {
                  width: 100%;
                  padding-top: 60px;
                  padding-left: 8px;
                  z-index: 1;

                  .name {
                    font-size: 32px;
                    font-family: Microsoft YaHei-Light;
                    font-weight: 600;
                    color: #666666;
                    line-height: 46px;
                  }

                  .position {
                    margin-top: 12px;
                    width: 96%;
                    font-size: 18px;
                    font-family: Microsoft YaHei-Light;
                    font-weight: 400;
                    color: #666666;
                    line-height: 24px;
                  }
                }

                .swiper-img {
                  width: 100% !important;
                  //height: 532px !important;
                  position: absolute;
                  bottom: 0;
                  //object-fit: none;
                  //object-position: -50px top;
                  z-index: 2;
                }

                .select-img {
                  display: none;
                }
                .select-img1-default {
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  top: 0;
                  right: 0;
                  z-index: 0;
                }
              }

              .swiper-slide-active {
                height: 600px;
                width: 350px !important;
                background: rgba(208, 235, 255, 0.28)
                  linear-gradient(
                    322deg,
                    #ffffff 0%,
                    rgba(255, 255, 255, 0) 100%
                  );
                opacity: 1;
                filter: blur(undefinedpx);
                position: relative;

                .swiper-text {
                  width: 100%;
                  padding-top: 20px;
                  padding-left: 30px;

                  .name {
                    font-size: 32px;
                    font-family: Microsoft YaHei-Light;
                    font-weight: 600;
                    color: #333333;
                    line-height: 46px;
                  }

                  .red-line {
                    width: 53px;
                    height: 4px;
                    margin-top: 10px;
                    margin-bottom: 20px;
                    background: #b4251e;
                    border-radius: 0px 0px 0px 0px;
                    opacity: 1;
                  }

                  .position {
                    width: 80%;
                    font-size: 18px;
                    font-family: Microsoft YaHei-Light;
                    font-weight: 400;
                    color: #666666;
                    line-height: 24px;
                  }
                }

                .swiper-img {
                  width: 100% !important;
                  //height: 618px !important;
                  position: absolute;
                  bottom: 0;
                  z-index: 1;
                  //object-fit: none;
                  //object-position: 0 bottom;
                }

                .select-img {
                  display: block;
                  width: 348px;
                  height: 410px;
                  position: absolute;
                  top: 0;
                  right: 0;
                  z-index: 0;
                }
              }

              .swiper-slide-prev {
                height: 100%;
                width: 250px !important;
              }

              .active {
                height: 600px;
                width: 350px !important;
                background: rgba(208, 235, 255, 0.28)
                  linear-gradient(
                    322deg,
                    #ffffff 0%,
                    rgba(255, 255, 255, 0) 100%
                  );
                opacity: 1;
                filter: blur(undefinedpx);
                position: relative;

                .swiper-text {
                  width: 100%;
                  padding-top: 60px;
                  padding-left: 30px;

                  .name {
                    font-size: 32px;
                    font-family: Microsoft YaHei-Light;
                    font-weight: 600;
                    color: #333333;
                    line-height: 46px;
                  }

                  .red-line {
                    width: 53px;
                    height: 4px;
                    margin-top: 10px;
                    margin-bottom: 20px;
                    background: #b4251e;
                    border-radius: 0px 0px 0px 0px;
                    opacity: 1;
                  }

                  .position {
                    width: 80%;
                    font-size: 18px;
                    font-family: Microsoft YaHei-Light;
                    font-weight: 400;
                    color: #666666;
                    line-height: 24px;
                  }
                }

                .swiper-img {
                  width: 348px !important;
                  //height: 618px !important;
                  position: absolute;
                  bottom: 0;
                  z-index: 1;
                  //object-fit: none;
                  //object-position: 0 bottom;
                }

                .select-img {
                  display: block;
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  top: 0;
                  right: 0;
                  z-index: 0;
                }
              }
            }
          }

          .hoverguest {
            color: #b4251e;
            width: 583px;
            height: 201px;
            padding: 16px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            .img {
              width: 301px;
              height: 168px;
              position: relative;

              .guestImg {
                width: 301px;
                height: 168px;
                border-radius: 20px 20px 20px 20px;
                position: absolute;
                top: 0;
                left: 0;
              }

              .pauseImg {
                width: 38px;
                height: 34px;
                position: absolute;
                top: 67px;
                left: 131px;
              }
            }

            .describe {
              height: 168px;

              .text {
                width: 210px;
                height: 78px;
                font-size: 18px;
                font-family: Microsoft YaHei-Light;
                font-weight: 600;
                color: #151e26;
                line-height: 26px;
              }

              .link {
                width: 70px;
                height: 24px;
                font-size: 12px;
                font-family: Microsoft YaHei-Light;
                font-weight: 400;

                color: #b4251e;
                line-height: 24px;

                img {
                  margin-left: 5px;
                }
              }
            }
          }
        }
      }

      .wap {
        display: none;
      }
    }
  }
}

@media screen and (max-width: 992px) {
  #guest {
    width: 100%;
    padding-top: 143px;
    //padding-bottom: 0px;
    //padding-bottom: 143px;

    .guest-container {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 750px;

      .pc {
        display: none;
      }

      .wap {
        width: 100%;
        height: 900px;
        overflow: hidden;

        ::v-deep .swiper-container-guest-wap {
          position: relative;

          .swiper-slide {
            width: 74% !important;
          }

          .swiper-slide-active {
            transition: 200ms;
            transform: scale(1) !important;
            background: rgba(208, 235, 255, 0.28)
              linear-gradient(322deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
            opacity: 1;
            border: 1px solid;
            border-image: linear-gradient(
                7deg,
                rgba(255, 255, 255, 0),
                rgba(255, 255, 255, 0.62)
              )
              2 2;
            filter: blur(undefinedpx);
            background-image: url("../assets/images/guest/home/select-bg-mobile.png");
            background-repeat: no-repeat;
            background-position: 100% 0;
            background-size: 100% 100%;
          }

          .swiper-slide-prev {
            //right: -4%;
            transition: 200ms;
            transform: scale(0.9) !important;
            background: rgba(255, 255, 255, 0.26);
            opacity: 1;
            border: 1px solid;
            border-image: linear-gradient(
                160deg,
                rgba(255, 255, 255, 1),
                rgba(235, 235, 235, 0),
                rgba(235, 235, 235, 0),
                rgba(255, 255, 255, 0.62)
              )
              2 2;
            filter: blur(undefinedpx);
            background-image: url("../assets/images/guest/home/select-bg-mobile.png");
            background-repeat: no-repeat;
            background-position: 100% 0;
            background-size: 0;
            background-image: none;
          }

          .swiper-slide-next {
            //left: -4%;
            transition: 200ms;
            transform: scale(0.9) !important;
            background: rgba(255, 255, 255, 0.26);
            opacity: 1;
            border: 1px solid;
            border-image: linear-gradient(
                160deg,
                rgba(255, 255, 255, 1),
                rgba(235, 235, 235, 0),
                rgba(235, 235, 235, 0),
                rgba(255, 255, 255, 0.62)
              )
              2 2;
            filter: blur(undefinedpx);
            background-image: url("../assets/images/guest/home/select-bg-mobile.png");
            background-repeat: no-repeat;
            background-position: 100% 0;
            background-size: 0;
            background-image: none;
          }

          .swiper-pagination-news {
            position: absolute;
            bottom: 0px;
            left: 0;
            z-index: 10;
          }

          .my-bullet {
            width: 26px;
            height: 8px;
            background: #c4c4c4;
            border-radius: 0px 0px 0px 0px;
            opacity: 1;
            margin: 0 5px;
          }

          .my-bullet-active {
            background: #b4251e;
          }
        }

        .slide {
          padding-top: 69px;
          padding-left: 60px;
          position: relative;
          width: 100%;
          height: 710px;
          opacity: 1;
          filter: blur(undefinedpx);
          transform: translate3d(0, 0, 0);

          .swiper-text {
            width: 100%;
            height: auto;

            .name {
              height: 46px;
              font-size: $font-xxxl;
              font-family: Microsoft YaHei-Light;
              font-weight: 600;
              color: #333333;
              line-height: 46px;
            }

            .red-line {
              width: 53px;
              height: 4px;
              margin-top: 11px;
              margin-bottom: 17px;
              background: #b4251e;
              border-radius: 0 0 0 0;
              opacity: 1;
            }

            .position {
              width: 400px;
              height: 36px;
              font-size: 24px;
              font-family: Microsoft YaHei-Light;
              font-weight: 400;
              color: #666666;
              line-height: 36px;
              //-webkit-background-clip: text;
              //-webkit-text-fill-color: transparent;
            }
          }

          .swiper-img {
            width: 426px;
            //height: 531px;
            position: absolute;
            bottom: 0;
            right: 0;
          }
        }
      }
    }

    .link-new {
      width: 100%;
      height: 30px;
      margin-top: 30px;
      font-size: 12px;

      span {
        height: 30px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;

        color: #b4251e;
        line-height: 30px;
        font-size: 24px;
        border-bottom: 1px solid #b4251e;
        padding-bottom: 1px;
      }
    }
  }
}
</style>
